import { render, staticRenderFns } from "./mobile-switcher.vue?vue&type=template&id=db439154"
import script from "./mobile-switcher.ts?vue&type=script&lang=js&external"
export * from "./mobile-switcher.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports